export default __webpack_public_path__ + "static/media/Moongate.c7023577.png";